module.exports = __webpack_public_path__ + "static/img/红果研.380f5fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Process/img/红果研.jpg
// module id = 9yUn
// module chunks = 1